// extracted by mini-css-extract-plugin
export default {"container":"ExamplesSection_container__w2e3t","subtitle":"ExamplesSection_subtitle__LC1wT"};